import { render, staticRenderFns } from "./NameColumn.vue?vue&type=template&id=0dae7a76"
import script from "./NameColumn.vue?vue&type=script&lang=js"
export * from "./NameColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports